import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';

import IconCalendar from '@white-label-icon/icon-calendar';

import {
  formatWithLocale,
  DATE_TIME_FORMATS,
} from '@white-label-helper/date-utilities';
import { useCountryOptions } from '@white-label-helper/shared-composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-travel-insurance-trip-details',
  props: {
  product: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { proxy } = getCurrentInstance() as any;
const i18n = proxy.$i18n;

const { getCountryById } = useCountryOptions();



const destinationsString = computed<string>(() => {
  const codes = props.product?.quoteDetails?.destination ?? [];
  return codes.map((code: string) => getCountryById(code).name).join(', ');
});

const formatDate = (date: string ) => {
  return formatWithLocale(new Date(date), DATE_TIME_FORMATS.weekday_day_month_year_no_comma, i18n.locale);
};

return { __sfc: true,proxy, i18n, getCountryById, props, destinationsString, formatDate, IconCalendar }
}

})